// extracted by mini-css-extract-plugin
module.exports = {"section":"SolutionRequest_section__UYNJd","image":"SolutionRequest_image__u7mAG","title":"SolutionRequest_title__JxVMU","subtitle":"SolutionRequest_subtitle__Sj_Qe"};